import { Box, Text, Table, TableContainer, Tbody, Td, Th, Thead, Tr, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './holidayCalender.style'
import { CustomToast } from '../../../../components'
import { useFetch } from '../../../../hooks/useFetch'
import { useEffect, useState } from 'react'
import { Data } from './modal'
import { showDate } from '../../../../utilities/helper'

const HolidayCalendar = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [holidayCalendar, setHolidayCalendar] = useState<Data[]>([]);
  const Header = [{ id: 1, name: 'Holiday' }, { id: 2, name: 'Business Name' }, { id: 3, name: 'Day' }, { id: 4, name: 'Department Name' }, { id: 5, name: 'Date' },];
  const loadHolidayList = async () => {
    const response = await fetchApi("Hrlense_Holiday/holidayList", "GET", null, null, "");
    if (response) {
      setHolidayCalendar(response)
    }
  }
  useEffect(() => { loadHolidayList() }, [])

  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Text className="font-poppins text_medium text_lg" mb={2}> Holiday Calendar </Text>
        <Box position="relative" minH="300px">
          {loading ? (
            <Center position="absolute" top={0} left={0} right={0} bottom={0}>
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
            </Center>) : (
            <>
              {holidayCalendar.length > 0 ? (
                <TableContainer  >
                  <Box borderRadius="2px"  >
                    <Table variant="unstyled" >
                      <Thead bg="#242424">
                        <Tr>
                          {Header.map((title) => (
                            <Th key={title.id} color="white" textAlign="center" fontWeight="semibold" fontSize="sm" py={3} bg="#242424" >{title.name} </Th>
                          ))}
                        </Tr>
                      </Thead>

                      <Tbody className="font-poppins text_medium text_md">
                        {holidayCalendar.map((item, index) => (
                          <Tr key={index}>
                            <Td border="1px solid #242424" textAlign="center" verticalAlign="middle" h="65px" >{item.holidayName}</Td>
                            <Td border="1px solid #242424" textAlign="center" verticalAlign="middle">{item.businessProcessName}</Td>
                            <Td border="1px solid #242424" textAlign="center" verticalAlign="middle" >{item.dayName}</Td>
                            <Td border="1px solid #242424" textAlign="center" verticalAlign="middle">{item.departmentName}</Td>
                            <Td border="1px solid #242424" textAlign="center" verticalAlign="middle">{showDate(item.holiday_Date)}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                </TableContainer>
              ) : (
                <Box p={8} textAlign="center" color="gray.500" className="font-poppins text_regular text_md" >No Data Available</Box>
              )}
            </>)}
        </Box>
      </Box>
    </MyDiv>
  )
}

export default HolidayCalendar
